import React from "react";
import Button from "../button/button";

const PaginationSelectNumberOfResultsPerPage = props => {
	return (
		//
		<div
			className={`pagination-select-number-of-results-per-page ${props.isOpen ? "pagination-select-number-of-results-per-page--is-open" : ""
				}`}
			id={props.id}
		>
			{props.isOpen && (
				<div className="pagination-select-number-of-results-per-page__selectors">
					Exibir:
					<Button
						className={`pagination-select-number-of-results-per-page--button-selector ${props.activeNumberOfResults === 20 ? "btn-secondary-sm-o" : "btn-gray-sm-o"
							} `}
						onClick={e => props.handleChangeNumberOfResults(20)}
						data-action="pagination-select-number-of-results-per-page-twenty"
					>
						20
					</Button>
					<Button
						className={`pagination-select-number-of-results-per-page--button-selector ${props.activeNumberOfResults === 50 ? "btn-secondary-sm-o" : "btn-gray-sm-o"
							}`}
						onClick={e => props.handleChangeNumberOfResults(50)}
						data-action="pagination-select-number-of-results-per-page-fifty"
					>
						50
					</Button>
					<Button
						className={`pagination-select-number-of-results-per-page--button-selector ${props.activeNumberOfResults === 100 ? "btn-secondary-sm-o" : "btn-gray-sm-o"
							}`}
						onClick={e => props.handleChangeNumberOfResults(100)}
						data-action="pagination-select-number-of-results-per-page-hundred"
					>
						100
					</Button>
				</div>
			)}
			<Button
				className={`btn-gray-md-icon pagination-select-number-of-results-per-page--button-action ${props.isOpen ? "pagination-select-number-of-results-per-page--button-action--is-open" : ""
					}`}
				onClick={e => props.handleOpenOrCloseActions(e)}
				data-action="pagination-select-number-of-results-per-page-grid"
			>
				<i className="icon-grid stay-green" />
			</Button>
		</div>
	);
};

export default PaginationSelectNumberOfResultsPerPage;
